export const PAYMENT_METHOD = {
    EXISTING: 'existing_payment_method',
    NEW: 'new_payment_method',
    PAYPAL: 'pay_with_paypal',
}

export const ORDER_CANCELLED = 'order_cancelled'
export const ORDER_CANCELLED_F = 'order_cancelled_f'
export const PAYMENT_METHOD_FAILED_LIMIT_EXCEEDED =
    'payment_method_failed_limit_exceeded'

export const DUPLICATE_ORDER = 'duplicate_order'

export const AUTH_FAILED = 'auth_failed'

export const PROMO_CODE_ALREADY_USED = 'promo_code_already_used'

export const RECAPTCHA_RESUBMIT_FUNCTION = {
    LOGIN: 'login',
    SIGNUP: 'signup',
}
